<div class="modal fade" id="modal_tutorial" 
     tabindex="-1" 
     role="dialog" 
     aria-labelledby="tutorialModalLabel" 
     aria-modal="true" 
     aria-describedby="tutorialContent"
     *ngIf="tutorial">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title" id="tutorialModalLabel">{{ tutorial?.title }}</h5>
        <button type="button" 
                class="close" 
                data-dismiss="modal" 
                aria-label="Close" 
                (click)="hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      
      <!-- Modal Body -->
      <div class="modal-body" id="tutorialContent">
        <!-- Step Counter (hidden for single-step announcements) -->
        <div *ngIf="!isSingleStep" class="step-counter text-muted mb-3">
          Step {{ currentStepNumber }} of {{ totalSteps }}
        </div>
        
        <!-- Step Title -->
        <h6 class="step-title mb-3">{{ currentStep?.title }}</h6>
        
        <!-- Step Content -->
        <div class="step-content" [innerHTML]="currentStep?.content"></div>
        
        <!-- Step Image (if available) -->
        <div *ngIf="currentStep?.imageUrl" class="step-image mt-3">
          <img [src]="currentStep?.imageUrl" 
               [alt]="currentStep?.title" 
               class="img-fluid"
               loading="lazy">
        </div>
      </div>
      
      <!-- Modal Footer -->
      <div class="modal-footer d-flex justify-content-between">
        <!-- Single-step announcement style footer -->
        <ng-container *ngIf="isSingleStep; else multiStepFooter">
          <!-- No Thanks Button (dismiss) -->
          <button type="button" 
                  class="btn btn-outline-secondary" 
                  (click)="skipTutorial()" 
                  aria-label="Dismiss this announcement">
            No Thanks
          </button>
          
          <!-- Show Me / Action Button (primary action + complete) -->
          <button *ngIf="isActionButtonVisible && currentStep?.actionButton; else singleStepFinish"
                  type="button" 
                  class="btn"
                  [ngClass]="currentStep?.actionButton?.buttonClass || 'btn-primary'"
                  (click)="handleShowMeClick()"
                  [disabled]="actionInProgress"
                  [title]="currentStep?.actionButton?.tooltip || ''">
            <fa-icon *ngIf="getActionButtonIcon()" 
                     [icon]="getActionButtonIcon()"
                     class="mr-2">
            </fa-icon>
            {{ currentStep?.actionButton?.action?.label }}
          </button>
          <ng-template #singleStepFinish>
            <button type="button" 
                    class="btn btn-primary" 
                    (click)="nextStep()"
                    aria-label="Got it">
              Got It <fa-icon [icon]="faCheck"></fa-icon>
            </button>
          </ng-template>
        </ng-container>
        
        <!-- Multi-step tutorial footer -->
        <ng-template #multiStepFooter>
          <!-- Skip Button (left side) -->
          <button type="button" 
                  class="btn btn-outline-secondary" 
                  (click)="skipTutorial()" 
                  aria-label="Skip this tutorial">
            Skip Tutorial
          </button>
          
          <!-- Navigation Buttons (right side) -->
          <div class="button-group">
            <!-- Previous Button -->
            <button type="button" 
                    class="btn btn-secondary mr-2" 
                    (click)="previousStep()" 
                    [disabled]="isFirstStep"
                    aria-label="Previous step">
              <fa-icon [icon]="faArrowLeft"></fa-icon> Previous
            </button>
            
            <!-- Next / Finish Button -->
            <button type="button" 
                    class="btn btn-primary" 
                    (click)="nextStep()"
                    [attr.aria-label]="isLastStep ? 'Finish tutorial' : 'Next step'">
              {{ isLastStep ? 'Finish' : 'Next' }} 
              <fa-icon [icon]="isLastStep ? faCheck : faArrowRight"></fa-icon>
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
